import { PropsWithChildren } from "react"
import { Outlet } from "react-router-dom"
import styled from "styled-components"

import { useAppSelector } from "store/hooks"
import { contractorThemeSelector } from "store/tempDataSlise"
import { ContractorThemes } from "constants/ContractorThemes"
import SubscriptionPlan from "types/enums/SubscriptionPlan"

import { checkRoleType } from "utils/checkRoleType"
import { ContractorTopbar } from "components/topbars/ContractorTopbar"
import { SalesManagerTopbar } from "components/topbars/SalesManagerTopbar"
import { VendorTopbar } from "components/topbars/VendorTopbar"
import { WerehouseTopbar } from "components/topbars/WerehouseTopbar"

import useUserProfileSync from "./useUserProfileSync"

const StyledPageWrapper = styled.section<{ backgroundStyle: string }>`
  min-height: 100vh;
  background: ${({ backgroundStyle }) => backgroundStyle};
`

const MainLayout = ({ children }: PropsWithChildren) => {
  useUserProfileSync()
  const userProfile = useAppSelector(state => state.user.userProfile)
  const userRole = checkRoleType(userProfile?.type)
  const hasEPlusPlan = userProfile?.contractor?.subscription_plan === SubscriptionPlan.E_PLUS
  const currentTheme = useAppSelector(contractorThemeSelector)

  const getBackgroundStyle = (hasEPlusPlan: boolean) => {
    if (hasEPlusPlan || !userProfile) {
      return currentTheme.backgroundGradient
    }
    return ContractorThemes.default.backgroundGradient
  }

  const setNecessaryTopbar = () => {
    if (
      ["contractor-manager", "contractor-admin", "contractor-engineer", "contractor-technician"].includes(
        userRole || "",
      )
    ) {
      return <ContractorTopbar />
    }
    if (userRole === "vendor-admin") {
      return <VendorTopbar />
    }
    if (userRole === "warehouse-manager") {
      return <WerehouseTopbar />
    }
    if (userRole === "sales-manager") {
      return <SalesManagerTopbar />
    }
    return null
  }

  return (
    <StyledPageWrapper backgroundStyle={getBackgroundStyle(hasEPlusPlan)}>
      {setNecessaryTopbar()}
      {children}
      <Outlet />
    </StyledPageWrapper>
  )
}

export default MainLayout
